import React, { useContext, useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { ColorContext } from 'App';

const PasswordInput = ({
  label = 'Password',
  placeholder = 'Enter password',
  value,
  callback,
  isInvalid = false,
  isValid = false,
  feedback = '',
  width,
  height = 50,
  controlId = 'password-input',
}) => {
  const [reveal, setReveal] = useState(false);
  const theme = useContext(ColorContext);

  return (
    <Form.Group controlId={controlId} style={{ width }}>
      {label && <Form.Label className="mb-1">{label}</Form.Label>}

      <InputGroup>
        <Form.Control
          type={reveal ? 'text' : 'password'}
          value={value}
          onChange={(e) => callback(e.target.value)}
          placeholder={placeholder}
          isInvalid={isInvalid}
          isValid={isValid}
          className="shadow-none border-0"
          style={{
            backgroundColor: theme.primary,
            color: theme.fontColor,
            height,
          }}
        />

        <Button
          variant="outline-secondary"
          onClick={() => setReveal((s) => !s)}
          aria-label={reveal ? 'Hide password' : 'Show password'}
          aria-pressed={reveal}
          className="d-flex align-items-center shadow-none border-0"
          style={{
            backgroundColor: theme.primary,
            color: theme.fontColor,
          }}
        >
          {reveal ? <FaEyeSlash /> : <FaEye />}
        </Button>

        {isInvalid && feedback && (
          <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
        )}
      </InputGroup>
    </Form.Group>
  );
};

export default PasswordInput;
